export const SERVER_ERROR_MESSAGES = {
  AUTHENTICATION_FAILURE: "Decoding Firebase ID token failed",
};

export const DISPLAY_ERROR_MESSAGES = {
  TRY_AGAIN: "Error processing request, please refresh and try again",
};
